"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RingOnIcon = ({ className, width = '18', height = '18', onClick, }) => {
    return (react_1.default.createElement("div", { onClick: onClick, role: onClick ? 'button' : undefined },
        react_1.default.createElement(react_1.default.Suspense, { fallback: null },
            react_1.default.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "transparent", className: className, xmlns: "http://www.w3.org/2000/svg" },
                react_1.default.createElement("path", { d: "M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z", stroke: "#2841ED", strokeWidth: "3" })))));
};
exports.default = RingOnIcon;
//# sourceMappingURL=RingOnIcon.js.map